import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import {IoHelpCircleOutline} from "react-icons/io5";
import {AiFillCloseCircle} from "react-icons/ai";
import {IoIosArrowDown} from "react-icons/io";
import {HiCursorClick} from "react-icons/hi"
import {MdTouchApp} from "react-icons/md"
import { VERSION_NUMBER } from '../Utils/utilFunctions';

import "../../styles/UIDetails.css"

// Menù secondario con i dettagli
export default function UIDetails() {
    const consoleVisibility = useSelector(state => state.uiConsoleMenu.isVisible);
    const consoleMessage = useSelector(state => state.uiConsoleMenu.messaggio);
    const darkTheme = useSelector(state => state.uiMenuState.darkTheme);

    const [detailsFloatingValue, setDetailsFloatingValue] = useState("-600px");
    const [detailMenuIsOpen, setDetailMenuIsOpen] = useState(false);
    const [helpBannerIsVisible, setHelpBannerIsVisible] = useState(true);

    // Chiude il menù help
    const handleBanner = () => {
        setDetailMenuIsOpen(true);
        setDetailsFloatingValue("0");
        setHelpBannerIsVisible(false);
    }
    // Apre il menù help
    const handleDetails = () => {
        setDetailMenuIsOpen(false);
        setDetailsFloatingValue("-600px");
        setHelpBannerIsVisible(true);
    }  

    return (
        <> 
            {helpBannerIsVisible && <div className='mainMenu' onClick={handleBanner}>
                <IoHelpCircleOutline size={24} color={"#061533b9"} />
                <p>HELP</p>
            </div>}  
            {detailMenuIsOpen && <div className='datails__closeIcon'>
                <AiFillCloseCircle size={32} color={"orange"} onClick={handleDetails}/>
            </div>}       
            <div className='details' style={{right: detailsFloatingValue}}>    
                <div className='details__mainInstructions'>                      
                        <div className="details__riga">
                                <IoIosArrowDown  size={24} color={"#ffffff"}/>
                                <p>Fai <span className='details__riga__span'>CLICK</span> sulla freccia del menù per espandere e comprimere la sezione del menù principale.</p>
                        </div>
                        <br/>
                        <div className='details__riga__title'> 
                                <div>MOUSE</div>
                        </div>
                        <div className="details__riga">
                                <HiCursorClick size={20} color={"#ffffff"}/>
                                <p>Fai <span className='details__riga__span'>CLICK SINISTRO</span> e <span className='details__riga__span'>MUOVI</span> il mouse per ruotare la telecamera.</p>
                                </div>
                        <div className="details__riga">
                                <HiCursorClick size={20} color={"#ffffff"}/>
                                <p>Fai <span className='details__riga__span'>CLICK DESTRO</span> e <span className='details__riga__span'>MUOVI</span> il mouse per spostare la panoramica.</p>
                        </div>                       
                        <div className="details__riga">
                                <HiCursorClick size={20} color={"#ffffff"}/>
                                <p>Usa la <span className='details__riga__span'>ROTELLINA</span> oppure fai <span className='details__riga__span'>CLICK CENTRALE</span> per zoomare.</p>
                        </div>
                        <br/>
                        <div className='details__riga__title'> 
                                <div>TOUCH</div>
                        </div>
                        <div className='details__riga'>
                                <MdTouchApp size={20} color={"#ffffff"}/>
                                <p>Appoggia il <span className='details__riga__span'>DITO</span> sullo schermo e <span className='details__riga__span'>TRASCINA</span> per ruotare la telecamera.</p>
                        </div>            
                        <div className="details__riga">
                                <MdTouchApp size={20} color={"#ffffff"}/>                          
                                <p>Appoggia <span className='details__riga__span'>DUE DITA</span> sullo schermo e <span className='details__riga__span'>TRASCINA</span> per spostare la panoramica.</p>
                        </div>
                        <div className="details__riga">
                                <MdTouchApp size={20} color={"#ffffff"}/>                         
                                <p>Appoggia <span className='details__riga__span'>DUE DITA</span> sullo schermo e <span className='details__riga__span'>DISTANZIALE o AVVICINALE</span> per zoomare.</p>
                        </div>
                </div>    
            </div>       
            <div className='details__footer'>           
                <div className='details__footer__title' style={{color: darkTheme ? "#909090" : "#e1e1e1"}}>- Ombrellificio il Parco - Calcolatore 3D -</div>
                <div className='details__footer__text' style={{color: darkTheme ? "#909090" : "#e1e1e1"}}>Created by: <a className="details__footer__link" href='mailto:canazzamanuel@gmail.com'>Manuel Canazza</a></div>
                <div className='details__footer__version' style={{color: darkTheme ? "#909090" : "#e1e1e1"}}><span>Version n. </span><span>{VERSION_NUMBER}</span></div>
            </div>           
            <div className='secondaryInstructions'>
                <p className='secondaryInstructionsText'>{consoleVisibility && consoleMessage}</p>
            </div>            
        </>
    )
}
